/**
 * @module app.cm
 */

import { autoinject, bindingMode } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ComponentBase, SortDirection, Sorting } from 'app/shared/lib/essette-site';
import { IPopup } from 'app/shared/elements/popup-base';
import { SortChangeEvent } from 'app/shared/attributes/sortable-attribute';
import { localSort } from 'app/shared/lib/sorting';
import { deepClone } from 'app/shared/lib/utilities';
import * as CM from 'app/cm/models/essette-api';


@autoinject()
export class AcuitiesDisplayModal extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.array({ defaultBindingMode: bindingMode.oneTime })
    protected acuities: CM.Acuity[] = [];

    protected displayedAcuities: CM.Acuity[] | null = null;

    protected selectedAcuityId: string | null = null;
    private sorting: Sorting = new Sorting();

    ////****************** Element References ***************************************////
    protected $modal!: IPopup;


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
    }


    ////****************** Events ***************************************************////
    /** Handles the grid's sort event */
    protected applySort(event: SortChangeEvent): void {
        if(!this.displayedAcuities) return;

        const { property, direction } = event.detail;
        const { sorting } = this;
        if(direction === null) {
            sorting.remove(property);
        } else {
            sorting.add({
                reference: property,
                direction: direction === 'asc' ? SortDirection.Ascending : SortDirection.Descending
            });
        }

        if(this.sorting.entries.length > 0) localSort(this.displayedAcuities, sorting);
        else this.displayedAcuities = deepClone(this.acuities);
    }

    ////****************** Functions ************************************************////
    public open(selectedAcuityId: string | null = null): void {
        if(!this.displayedAcuities) this.displayedAcuities = deepClone(this.acuities);
        this.selectedAcuityId = selectedAcuityId;
        this.$modal.open();
    }
}
